import isBrowser from "./isBrowser";

export const PROFILE_KEY = "@me";

export const getSessionValue = key => {
    if (!isBrowser()) return null;

    let value = window.sessionStorage.getItem(key);

    try {
        if (value) return JSON.parse(value);
        return value;
    } catch {
        return value;
    }
};

export const setSessionValue = (key, value) => {
    if (!isBrowser()) return false;

    if (typeof value === "object") {
        value = JSON.stringify(value);
    }

    window.sessionStorage.setItem(key, value);

    return true;
};
